<template>
  <el-dropdown @command="lanChange">
    <span class="el-dropdown-link"> {{ localeNm }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in lan" :command="item" :key="item.id">{{ item.nm }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  data() {
    return {
      lan: [],
    }
  },
  computed: {
    localeNm() {
      const i18nLocale = this.$i18n.locale

      const found = this.lan.find((item) => item.id === i18nLocale)

      if (!found) {
        return ''
      }

      return found.nm
    },
  },

  mounted() {
    this.initLan()
  },

  methods: {
    lanChange(locale) {
      this.$i18n.locale = locale.id
    },

    async initLan() {
      const result = await this.$axios.get('/language').then((res) => res.data)
      this.lan = result
    },
  },
}
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
  white-space: nowrap;
}
</style>
